



































	// @ts-ignore
    import _ from './MPopupUploadLogo.ts'; export default _;
